<template>
    <div class="builder-wrapper" :class="{'menu-open': menuOpen}">
        <div class="menu">
            <span class="menu-link" @click="menuOpen=!menuOpen"><i class="fas" :class="{'fa-bars': !menuOpen, 'fa-times': menuOpen}"></i></span>
            <router-link :to="{name: 'Welcome'}"><img class="logo" src="../../../assets/logo.png"/></router-link>

            <div class="menu-options">
                <router-link :to="{name: 'Welcome'}"><i class="fas fa-home" style="margin: 0;"></i></router-link>
                <router-link :to="{name: 'Store'}" class="active"><i class="fas fa-shopping-cart"></i> Kit Store</router-link>
                <router-link :to="{name: 'Builder'}"><i class="fas fa-toolbox"></i> Kit Builder</router-link>
                <router-link :to="{name: 'Director'}"><i class="fas fa-bullhorn"></i> Escape It Director</router-link>
                <!--<a><i class="fas fa-user"></i></a>-->
                <a @click="logout()"><i class="fas fa-power-off"></i></a>
            </div>
        </div>

        <div class="builder-frame" :class="kitBackground">
            <div class="side-menu">
                <div class="main">
                    <router-link :to="{name: 'Builder'}" class="active"><i class="fas fa-toolbox"></i> Builder</router-link>
                    <router-link :to="{name: 'Director'}"><i class="fas fa-bullhorn"></i>Director</router-link>
                    <!--<a><i class="fas fa-user"></i></a>-->
                    <a @click="logout()"><i class="fas fa-power-off"></i></a>
                </div>
                <div class="store">
                    <header>
                        <h2><i class="far fa-shopping-cart"></i> Escape Room Kits</h2>
                    </header>
                    <ul class="store-kit-list">
                        <li class="kit kit1" :class="{'active': selectedKit===1}" @click="selectKit(1)">
                            <div class="title">Self Destruct</div>
                            <div class="teaser">As passengers on a ship you take to the stars when something goes terribly wrong. What will you do?</div>
                            <div class="own" v-if="kits.indexOf(1) !== -1">
                                <i class="fas fa-box-check"></i> You own this kit
                            </div>
                            <div class="price" v-else><i class="fas fa-shopping-cart"></i>
                                <span class="retail">$49.99</span>
                                <span class="price">$39.99</span>
                                <span class="sale">20% Off!</span>
                            </div>
                        </li>
                        <li class="kit kit2" :class="{'active': selectedKit===2}">
                            <div class="title">The Mansion Heist</div>
                            <div class="teaser">You and your team are employed to recover an object simply referred to as "the Artifact" in the ultimate heist job.</div>
                            <div class="own" v-if="kits.indexOf(2) !== -1">
                                <i class="fas fa-box-check"></i> You own this kit
                            </div>
                            <div class="price coming-soon" v-else><i class="fas fa-shopping-cart"></i> Coming Soon!</div>
                        </li>
                    </ul>
                </div>
            </div>

            <div>
                <div v-if="selectedKit">
                    <div class="content-frame store">
                        <div v-show="selectedKit===1">
                            <div class="kit-header">
                                <img src="../../../assets/kit_1_header.jpg">
                                <header>
                                    <h4><i class="far fa-box-full"></i> Self Destruct</h4>
                                </header>
                            </div>
                            <b-card>
                                <div class="item-content">
                                    <p>The year is 2144. Space travel between planets is a normal occurrence as various transport ships ferry passengers among the stars. You are on such a ship.</p>
                                    <p>Unfortunately, just as you settle in for the trip, something goes terribly wrong. An asteroid slams into the ship causing a malfunction that activates the ship’s self destruct! In a matter of minutes the ship will be destroyed!</p>
                                    <p>What will you do?</p>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <ul class="kit-meta">
                                                <li><i class="fas fa-users"></i> 4-12 Participants</li>
                                                <li><i class="far fa-door-closed"></i> Run Multiple Rooms</li>
                                                <li><i class="fas fa-birthday-cake" style="margin: 0 9px 0 3px;"></i> Ages 12 and Up</li>
                                                <li><i class="far fa-clock" style="margin: 0 8px 0 2px;"></i> 60 Minutes to Escape</li>
                                                <li><i class="fas fa-puzzle-piece" style="margin: 0 8px 0 2px;"></i> 9 Puzzles to Solve</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6">
                                            <ul class="kit-meta">
                                                <li><i class="fas fa-cut" style="margin: 0 7px 0 3px;"></i> 3 DIY Props Included</li>
                                                <li><i class="fas fa-music"></i> Audio and Visual Effects</li>
                                                <li><i class="fas fa-tv"></i> Display Device</li>
                                                <li><i class="far fa-tablet" style="margin: 0 8px 0 3px;"></i> Interact Device</li>
                                                <li><i class="fas fa-bullhorn"></i> Escape It Director</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <hr>
                                    <p>The Self Destruct Kit is an action-packed experience as participants race to disable the self destruct sequence as the ship breaks apart around them causing malfunctioning systems and chaos at every turn.</p>
                                    <p>The kit is complete with sound and visual effects and a variety of puzzles ranging from spacial reasoning, mathematics, pattern recognition and more. Participants will also use an Interact Device (Phone, Tablet, etc) and interface directly with the ship's system as they work to escape.</p>
                                    <p>It's great for small to large groups up to 12 participants and ages 12 and up &mdash; perfect for birthday parties, team-building exercises, classroom activities, etc.</p>
                                </div>
                            </b-card>

                        </div>
                    </div>

                    <div class="control">
                        <div class="control-info">
                            <div class="own" v-if="kits.indexOf(selectedKit) !== -1">
                                <i class="fas fa-box-check"></i> You own this kit. Build and customize your kit in the <i class="far fa-toolbox"></i> Kit Builder. <b-button size="sm" @click="buildKitNow()"><i class="fas fa-plus-square"></i> New Kit Build</b-button>
                            </div>
                            <div class="buttons" v-else>
                                <b-button variant="primary" @click="purchaseKit('Self Destruct')"><i class="fas fa-shopping-cart"></i> &nbsp;Purchase</b-button>
                                <span v-if="!appliedCoupon">
                                    <input v-model="coupon" placeholder="Coupon Code" />
                                    <b-button @click="applyCoupon()">Apply</b-button>
                                </span>
                                <span v-else class="applied-coupon">
                                    <strong>{{appliedCoupon.coupon}}</strong> applied for {{appliedCoupon.discount}}
                                    <b-button @click="removeCoupon()">Remove</b-button>
                                </span>
                            </div>
                        </div>

                        <div class="cost-box" @click="purchaseKit('Self Destruct')" v-if="kits.indexOf(selectedKit) === -1">
                            <i class="fas fa-shopping-cart"></i>
                            <span class="retail">$49.99</span>
                            <span class="sale">20% Off!</span>
                            <span class="price">{{price}}</span>
                        </div>
                    </div>
                </div>

                <div v-else class="content-frame empty">
                    <div class="full">
                        <img src="../../../assets/store_instructions_full_1.png" class="instructions-1"/>
                    </div>
                    <div class="collapsed">
                        <img src="../../../assets/build_instructions_collaped_1.png" class="instructions-1"/>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import auth from '../../../services/auth';
    import kits from "../../../services/kits";
    import coupons from "../../../services/coupons";
    import router from "../../../router";
    import Help from './help.vue';

    import Kit1Builder from "../../../kits/1/builder.vue";
    import Kit1Props from "../../../kits/1/props.vue";
    import Kit1Help from "../../../kits/1/help_builder.vue";

    let API_URL = 'https://api.escapeitkit.com:443/api/';
    if (location.hostname === 'localhost') {
        API_URL = 'http://localhost:9000/api/';
    }

    export default {
        name: "store",
        components: {
            Help, Kit1Builder, Kit1Props, Kit1Help
        },
        mounted() {
            this.$store.commit('setNavbarVisibility', false);
        },
        destroyed() {
            this.$store.commit('setNavbarVisibility', true);
        },
        data: function () {
            return {
                menuOpen: false,
                newBuildForm: false,
                newBuild: {
                    title: '',
                    kit: null
                },
                showMenu: false,
                mode: 'builds',
                view: 'empty', // Empty state
                kitBackground: 'none',
                selectedBuild: null,
                buildComponent: null,
                propsComponent: null,
                helpComponent: null,
                build: null,

                selectedKit: null,
                price: '$39.99',
                coupon: null,
                appliedCoupon: null,
                chargeAmount: 3999,

                API_URL: API_URL,
                AUTH: auth.getAuthHeader().Authorization.replace('Bearer ','')
            }
        },
        methods: {
            createBuild: function () {
                if (this.newBuild.kit) {
                    if (this.newBuild.title === '') {
                        if (this.newBuild.kit === "1") this.newBuild.title = 'Self Destruct';
                        if (this.newBuild.kit === "2") this.newBuild.title = 'The Mansion Heist';
                    }
                    kits.buildKit(this.newBuild.kit, this.newBuild.title).then(build => {
                        this.newBuild = {
                            title: '',
                            kit: null
                        };
                        this.newBuildForm = false;
                        this.selectBuild(build);
                    });
                } else {
                    window.alert('Please choose a kit.');
                }
            },
            buildKitNow: function () {
                this.setMode('builds');
                this.newBuildForm = true;
            },
            setMode: function (mode) {
                this.kitBackground = 'none';
                this.buildComponent = null;
                this.propsComponent = null;
                this.helpComponent = null;
                this.build = null;
                this.selectedBuild = null;
                this.selectedKit = null;
                this.newBuildForm = false;

                if (mode === 'builds') this.view = 'empty';

                this.mode = mode;
            },
            setView: function (view) {
                this.view = view;
            },
            selectBuild: function (build) {
                this.selectedBuild = build;

                kits.getBuild(build.id).then(build => {
                    this.build = build;
                    this.buildComponent = 'kit' + build.kit_id + '-builder';
                    this.propsComponent = 'kit' + build.kit_id + '-props';
                    this.helpComponent = 'kit' + build.kit_id + '-help';
                    this.kitBackground = 'kit' + build.kit_id;
                    this.view = 'download';
                }, err => {
                    console.log(err);
                    window.alert('An error occurred.');
                    router.push({name: 'Builder'});
                });
            },
            deleteBuild: function(build_id) {
                if (confirm('Are you sure you want to delete this build? This is a permanent action.')) {
                    kits.deleteBuild(build_id).then(response => {
                        this.kitBackground = 'none';
                        this.buildComponent = null;
                        this.propsComponent = null;
                        this.helpComponent = null;
                        this.build = null;
                        this.selectedBuild = null;
                    })
                }
            },
            selectKit: function(kit_id) {
                this.selectedKit = kit_id;
            },
            applyCoupon() {
                if (this.coupon) {
                    coupons.checkCouponCode(this.coupon, this.selectedKit).then(result => {
                        this.appliedCoupon = result;
                        this.coupon = result.coupon;
                        this.price = '$' + result.price;
                        this.chargeAmount = (parseFloat(result.price)*100);
                        console.log(result, this.chargeAmount);
                    }, err => {
                        window.alert('That\'s not a valid coupon code.');
                    });
                }
            },
            removeCoupon() {
                this.appliedCoupon = null;
                this.price = '$39.99';
                this.chargeAmount = 3999;
                this.coupon = null;
            },
            purchaseKit(kit) {
                if (this.chargeAmount === 0) {
                    // Free?
                    kits.purchaseKit(this.selectedKit, '', (this.appliedCoupon) ? this.appliedCoupon.coupon : null).then(() => {
                        this.selectedKit = null;
                        this.appliedCoupon = null;
                        this.price = '$39.99';
                        this.chargeAmount = 3999;
                        this.coupon = null;

                        // TODO
                        this.kits.push(1);
                    }, err => {
                        console.log(err);
                        window.alert('An error occurred.');
                    });
                } else {
                    this.$checkout.open({
                        name: kit,
                        currency: 'USD',
                        amount: this.chargeAmount,
                        panelLabel: 'Purchase Kit - {{amount}}',

                        token: (token) => {
                            kits.purchaseKit(this.selectedKit, token, (this.appliedCoupon) ? this.appliedCoupon.coupon : null).then(() => {
                                this.selectedKit = null;
                                this.appliedCoupon = null;
                                this.price = '$39.99';
                                this.chargeAmount = 3999;
                                this.coupon = null;

                                // TODO
                                this.kits.push(1);
                            }, err => {
                                console.log(err);
                                window.alert('An error occurred.');
                            });
                        }
                    });
                }
            },
            logout() {
                auth.logout();
            }
        },
        computed: {
            options: function () {
                let options = [];
                let builds = this.$store.getters['user/builds'];
                for (let i = 0; i < builds.length; i++) {
                    let build = builds[i];
                    options.push({value: build, text: build.title});
                }
                return options;
            },
            kits: function () {
                return this.$store.getters['user/kits'];
            },
            builds: function () {
                return this.$store.getters['user/builds'];
            },
            user: function() {
                return this.$store.getters['user/user'];
            }
        },
        filters: {
            capitalize: function (value) {
                if (!value) return '';
                value = value.toString();
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        }
    }

</script>

<style lang="scss" scoped>
    .builder-wrapper {
        font-family: "Roboto", sans-serif;

        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;

        .menu {
            margin: 0 auto;

            .logo {
                padding: 12px 0 0 10px;
                float: left;

                img {
                    max-width: 179px;
                    width: 100%;
                }

                @media (max-width: 770px) {
                    float: right;
                    margin-right: 16px;
                }
            }

            .menu-link {
                float: left;
                padding: 20px 0 0 20px;
                display: none;

                i {
                    font-size: 26px;
                }

                @media (max-width: 770px) {
                    display: inline-block;
                }
            }

            .menu-options {
                position: absolute;
                right: 0;

                a {
                    display: inline-block;
                    padding: 20px;
                    font-size: 18px;
                    color: rgba(255, 255, 255, 0.50);
                    height: 65px;

                    i {
                        font-size: 22px;
                        margin-right: 10px;
                        color: rgba(255, 255, 255, 0.50);
                    }

                    &:hover {
                        background-color: rgba(0, 0, 0, 0.30);
                        text-decoration: none;
                    }

                    &.active {
                        box-shadow: inset 0 3px 0 #e45114;
                        background-color: rgba(16, 16, 16, 0.98);
                        color: white;
                        i {
                            color: white;
                        }

                    }
                }

                @media (max-width: 770px) {
                    display: none;
                }
            }
        }

        .builder-frame {
            margin: 0 auto;
            position: absolute;
            left: 0;
            right: 0;
            top: 65px;
            bottom: 0;

            background-color: rgba(0, 0, 0, 0.7);

            &.kit1 {
                background: #111 url('../../../assets/kit_1.jpg');
                background-size: cover;
            }

            .side-menu {
                position: absolute;
                width: 300px;
                bottom: 0;
                left: 0;
                top: 0;

                background-color: rgba(0, 0, 0, 0.9);

                .main {
                    display: none;
                    background-color: rgba(255, 255, 255, 0.1);

                    a {
                        display: inline-block;
                        padding: 10px 20px 8px 20px;
                        font-size: 14px;
                        color: rgba(255, 255, 255, 0.50);

                        i {
                            font-size: 15px;
                            margin-right: 5px;
                            color: rgba(255, 255, 255, 0.50);
                        }

                        &:hover {
                            background-color: rgba(0, 0, 0, 0.30);
                            text-decoration: none;
                        }

                        &.active {
                            box-shadow: inset 0 3px 0 #e45114;
                            background-color: rgba(0, 0, 0, 0.7);
                            color: white;
                            i {
                                color: white;
                            }

                        }
                    }

                    @media (max-width: 768px) {
                        display: block;
                    }
                }

                header {
                    background-color: rgba(255, 255, 255, 0.3);
                    margin-bottom: 2px;
                    min-height: 38px;

                    h2 {
                        padding: 10px 20px 0;
                        margin: 0;
                        float: left;
                        font-size: 16px;

                        i {
                            margin-right: 6px;
                        }
                    }

                    .new {
                        float: right;
                        border-radius: 0;
                        border: none;
                        margin: 0;
                        font-size: 1.1rem;
                        border-left: 2px solid rgba(0, 0, 0, 0.6);
                    }
                }

                .menu-options {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    left: 0;

                    ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;
                        display: flex;
                        justify-content: space-between;

                        li {
                            flex-grow: 1;

                            text-align: center;
                            font-size: 0.7rem;
                            color: rgba(255, 255, 255, 0.50);
                            padding: 12px 5px 10px;
                            background-color: rgba(255, 255, 255, 0.15);
                            border-left: 1px solid rgba(0, 0, 0, 0.6);
                            border-right: 1px solid rgba(0, 0, 0, 0.6);
                            width: 25%;
                            position: relative;

                            i {
                                display: block;
                                font-size: 20px;
                                margin-bottom: 6px;
                                color: white;
                            }

                            span.badge {
                                position: absolute;
                                top: 0;
                                right: 0;
                                border-radius: 0;
                                padding: 3px 5px;
                                background-color: rgb(1, 122, 255);
                                font-size: 10px;
                                font-weight: bold;

                                &.none {
                                    background-color: transparent;
                                    padding: 3px 4px 0 5px;

                                    i {
                                        color: red;
                                        font-size: 11px;
                                    }
                                }
                            }

                            &:first-child {
                                border-left: 0;
                            }

                            &:last-child {
                                border-right: 2px solid rgba(0, 0, 0, 0.6);
                            }

                            &:hover {
                                background-color: rgba(255, 255, 255, 0.20);
                            }

                            &.active {
                                box-shadow: inset 0 -3px 0 #e45114;
                                color: white;
                                background-color: transparent;

                            }
                        }
                    }
                }

                .builds {
                    .build-list {
                        list-style: none;
                        margin: 0;
                        padding: 0;

                        .build {
                            padding: 16px;
                            border-bottom: 2px solid #000;
                            cursor: pointer;
                            background-color: rgba(255, 255, 255, 0.15);
                            border-left: 3px solid transparent;

                            .title {
                                font-size: 18px;
                            }
                            .date {
                                font-size: 11px;
                                color: #bbbbbb;
                            }

                            &:hover {
                                background-color: rgba(255, 255, 255, 0.12);
                            }

                            &.active {
                                border-left: 3px solid #e45114;
                                background-color: rgba(255, 255, 255, 0.08);
                            }
                        }
                    }

                    .new-build-form {
                        position: absolute;
                        top: 38px;
                        left: 0;
                        right: 0;

                        padding: 16px;
                        background-color: #017AFF;

                        h5 {
                            font-size: 16px;
                            margin-bottom: 20px;

                            i {
                                margin-right: 8px;
                            }
                        }

                        input, select {
                            margin-bottom: 10px;
                        }

                        .buttons {
                            margin-top: 20px;
                            .btn-primary {
                                background: white;
                                color: black;
                            }
                            .btn-link {
                                color: white;
                            }
                        }

                        @media (max-width: 768px) {
                            top: 77px;
                        }
                    }
                }

                .store {
                    .store-kit-list {
                        list-style: none;
                        margin: 0;
                        padding: 0;

                        .kit {
                            padding: 16px;
                            cursor: pointer;
                            border-left: 3px solid transparent;

                            .title {
                                font-size: 18px;
                            }
                            .teaser {
                                font-size: 11px;
                                color: #bbbbbb;
                            }
                            .own {
                                font-size: 13px;
                                font-style: italic;
                                margin-top: 12px;
                                i {
                                    color: green;
                                    margin-right: 4px;
                                }
                            }
                            .price {
                                margin-top: 12px;
                                font-size: 13px;

                                .retail {
                                    text-decoration: line-through;
                                    color: rgba(255, 255, 255, 0.7);
                                    font-size: 0.85rem;
                                    margin-right: 4px;
                                }

                                .sale {
                                    padding: 2px 7px;
                                    margin-left: 15px;
                                    background-color: rgb(234, 104, 31);
                                }

                                i {
                                    color: green;
                                    margin-right: 6px;
                                }

                                &.coming-soon {
                                    i {
                                        color: rgb(234, 104, 31);
                                    }
                                }

                            }

                            &.kit1 {
                                background: #111 url('../../../assets/kit_1_header_faded.jpg');
                                background-size: cover;
                            }
                            &.kit2 {
                                background: #111 url('../../../assets/kit_2_header_faded.jpg');
                                background-size: cover;
                            }

                            &:hover {
                                background-color: rgba(255, 255, 255, 0.12);
                            }

                            &.active {
                                border-left: 3px solid #e45114;
                                background-color: rgba(255, 255, 255, 0.08);
                            }
                        }
                    }
                }

                @media (max-width: 768px) {
                    display: none;
                }
            }

            .control {
                position: absolute;
                bottom: 0;
                left: 300px;
                right: 0;
                background-color: rgba(40, 40, 40, 0.9);

                min-height: 64px;

                @media (max-width: 768px) {
                    left: 0;
                }

                .control-info {
                    position: absolute;
                    left: 0;

                    .own {
                        margin: 15px 0 0 25px;

                        font-size: 14px;
                        font-style: italic;


                        i.fa-box-check {
                            color: green;
                            margin-right: 4px;
                        }

                        i.fa-toolbox {
                            margin: 0 3px 0 5px;
                        }

                        .btn {
                            margin-left: 15px;

                            i {
                                color: white;
                            }
                        }
                    }

                    .buttons {
                        margin: 15px 0 0 25px;

                        i {
                            margin-right: 5px;
                        }
                    }
                }

                .menu-options {
                    position: absolute;
                    right: 0;
                    width: 280px;
                    height: 64px;

                    ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;
                        display: flex;
                        justify-content: space-between;

                        li {
                            flex-grow: 1;

                            text-align: center;
                            font-size: 0.7rem;
                            color: rgba(255, 255, 255, 0.50);
                            padding: 12px 5px 10px;
                            /*background-color: rgba(255, 255, 255, 0.15);*/
                            border-left: 1px solid rgba(0, 0, 0, 0.6);
                            border-right: 1px solid rgba(0, 0, 0, 0.6);
                            width: 25%;
                            position: relative;

                            i {
                                display: block;
                                font-size: 20px;
                                margin-bottom: 6px;
                                color: white;
                            }

                            &:first-child {
                                border-left: 2px solid rgba(0, 0, 0, 0.6);
                            }

                            &:last-child {
                                border-right: 0;
                            }

                            &:hover {
                                background-color: rgba(255, 255, 255, 0.20);
                            }

                            &.active {
                                box-shadow: inset 0 -3px 0 #e45114;
                                color: white;
                                background-color: rgba(0, 0, 0, 0.7);

                            }
                        }
                    }
                }

                .applied-coupon {
                    margin-left: 15px;

                    button {
                        margin-left: 15px;
                    }
                }
                .cost-box {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    color: white;
                    background: #ea681f;
                    padding: 15px 35px 15px 20px;
                    border-left: 4px solid white;
                    border-top: 4px solid white;
                    border-top-left-radius: 30px;
                    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
                    font-weight: normal;
                    cursor: pointer;

                    i {
                        margin-right: 10px;
                        font-size: 26px;
                        vertical-align: text-bottom;
                    }

                    .retail {
                        text-decoration: line-through;
                        color: rgba(255, 255, 255, 0.7);
                        font-size: 0.85rem;
                        margin-right: 4px;
                    }

                    .sale {
                        position: absolute;
                        top: 0;
                        right: 20px;
                        margin-top: -18px;
                        background: white;
                        padding: 3px 12px;
                        font-weight: bold;
                        color: black;
                        border-radius: 20px;
                        font-size: 14px;
                    }
                }

                input {
                    margin-left: 15px;
                    background-color: black;
                    border: 1px solid #333;
                    border-radius: 5px;
                    padding: 8px 10px;
                    color: white;
                }

                @media (max-width: 500px) {
                    .control-info {
                        position: static;
                        display: block;
                        left: auto;

                        padding: 5px 15px 5px 15px;
                        background-color: rgba(0, 0, 0, 0.7);

                        /*.icon {*/
                            /*padding: 10px 0 0;*/
                            /*float: right;*/
                            /*i {*/
                                /*font-size: 30px;*/
                            /*}*/
                        /*}*/

                        /*.room-name {*/
                            /*padding: 0;*/
                        /*}*/
                    }

                    .menu-options {
                        position: static;
                        display: block;
                        width: 100%;
                    }
                }
            }

            .content-frame {
                position: absolute;
                bottom: 64px;
                left: 300px;
                top: 0;
                right: 0;
                padding: 10px 10px 5rem 10px;

                overflow: auto;

                background-color: rgba(0, 0, 0, 0.8);

                @media (max-width: 768px) {
                    left: 0;
                }

                &.empty {
                    background: #111 url('../../../assets/dark_cartographer_bg.png');
                    bottom: 0;

                    .full {
                        .instructions-1 {
                            position: absolute;
                            top: 0;
                            left: 0;
                        }
                        .instructions-2 {
                            position: absolute;
                            top: 0;
                            right: 0;
                        }
                        .instructions-3 {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                        }

                        @media (max-width: 768px) {
                            display: none;
                        }
                    }

                    .collapsed {
                        display: none;

                        .instructions-1 {
                            position: absolute;
                            top: 0;
                            left: 0;
                        }

                        @media (max-width: 768px) {
                            display: block !important;
                        }
                    }

                }

                &.builds {
                    .info {
                        font-family: "Roboto", sans-serif;
                        line-height: 1.9rem;
                        padding: 25px 40px 0 40px !important;
                        font-size: 0.9rem;

                        ul.meta {
                            padding: 0;
                            list-style: none;

                            li {
                                display: inline-block;
                                font-size: 13px;
                                color: #aaa;
                                padding-right: 15px;

                                strong {
                                    color: #d9d9d9;
                                }
                            }
                        }

                        .delete-button {
                            font-weight: normal;
                            color: #666 !important;
                            text-decoration: none;
                            font-size: 13px;

                            &:hover, &:active {
                                color: #E45114 !important;
                            }
                        }

                        h2 {
                            font-family: 'Sumana', serif;
                            padding-bottom: 0;
                        }

                        h3 {
                            font-family: 'Sumana', serif;

                            font-size: 1.5rem;
                            border-bottom: 1px solid #E46A3B;
                            padding-bottom: 8px;
                            margin-bottom: 1.4rem;

                            i {
                                width: 30px;
                                margin-right: 0.5rem;
                            }
                        }

                        i {
                            margin: 0 6px;
                        }

                        ol li, ul li {
                            margin-bottom: 15px;
                            line-height: normal;
                        }

                        ol {
                            font-size: 16px;

                            li {
                                padding-left: 10px;
                                margin-bottom: 25px;
                            }

                            .task {
                                margin-bottom: 15px;
                            }

                            .btn {
                                padding-right: 15px;
                                margin-bottom: 10px;
                            }
                        }

                    }
                }

                &.store {
                    padding: 0;

                    .kit-meta {
                        list-style: none;
                        padding: 0;
                        margin-bottom: 0;

                        i {
                            color: #ea681f;
                            margin-right: 10px;
                            font-size: 18px;
                            width: 25px;
                        }

                        li {
                            margin-bottom: 5px;
                            font-size: 14px;
                        }
                    }

                    .kit-header {
                        position: relative;

                        header {
                            padding: 35px;
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            right: 0;

                            h4 {
                                font-size: 2rem;
                                margin-bottom: 0.5rem;
                                font-family: 'Sumana', serif;
                                color: white;
                                text-transform: none;

                                i {
                                    font-size: 3rem;
                                    margin-right: 10px;
                                }
                            }
                        }

                        img {
                            width: 100%;
                        }
                    }

                    .container {
                        margin: 0 0 3rem;
                        padding: 0;
                    }

                    .card {
                        background-color: rgb(27, 27, 27);
                        border-radius: 0;
                        padding: 20px;
                        font-size: 14px;

                        ul li {
                            font-size: 12px;
                        }
                    }
                }
            }

            @media (max-width: 500px) {
                .content-frame {
                    bottom: 123px;
                }
            }

        }

        &.menu-open {
            .builder-frame {
                .side-menu {
                    display: block;
                    z-index: 1000;
                    background: black;

                    -webkit-box-shadow: 5px 10px 50px 0 rgba(0,0,0,0.75);
                    -moz-box-shadow: 5px 10px 50px 0 rgba(0,0,0,0.75);
                    box-shadow: 5px 10px 50px 0 rgba(0,0,0,0.75);

                    transition: left 0.5s;

                    .menu-options ul li:last-child {
                        border-right: 0;
                    }
                }
                .content-frame {
                    /*display: none;*/
                    /*opacity: 0.4;*/
                }
                .control {
                    /*display: none;*/
                    /*opacity: 0.5;*/
                    /*background-color: rgba(0,0,0,0.9);*/

                    ul li {
                        display: none;
                    }

                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/app/store/store.vue